import * as gfunctions from '../../../js/generalFunctions';

CCL.checkoutGiftCard = {
  autoload: [
    ['addGiftCard', $('.apply-total').length > 0],
    ['removeGiftCard', $('.c-gift-card').length > 0],
    ['getGiftCardBalance', $('.gift-card-balance').length > 0],
    ['obcCredit', $('.apply-obc-credit').length > 0]
  ],
  targetElement: {},
  /* eslint-disable */
  alphaReg: /^[a-zA-Z\s]*$/, // regex to accept only alphabets and space
  emailReg: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, // regex to accept email
  phoneReg: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, // regex for phone number
  /* eslint-enable */

  obcCredit() {
    $('body').on('click', '.apply-obc-credit', (event) => {
      this.applyObcCredit(event);
    });

    $('body').on('focus blur', '.ccl_tooltip button', (event) => {
      $('.tooltip-onboard-credit .tooltip_text').toggleClass('open');
    });
  },

  checkNameValidation() {
    const email = $('#billTo_email').val();
    const fname = $('#billTo_firstName').val();
    const lname = $('#billTo_lastName').val();
    const phoneNo = $('#billTo_phoneNumberFormator').val();
    if (email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
      return true;
    }
    return false;
  },

  applyObcCredit(event) {
    let ajaxUrl = '/shop/checkout/multi/payment-method/apply/obc';
    if ($(event.currentTarget).hasClass('remove')) {
      ajaxUrl = '/shop/checkout/multi/payment-method/remove/obc';
    }
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done((res) => {
      if (res.orderSummary.obcApplied) {
        $('.order-summary-total').text('');
        $('.js-obc-message').html(res.orderSummary.appliedOBCAmountDescription);
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.payment-card-body.card-div').removeClass('disable-payment-div');
        $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').removeAttr('tabindex').removeAttr('aria-disabled');
        $('.btn.placeOrder').attr('disabled', 'disabled');
        $(event.target).addClass('remove');
        $(event.target).html('Remove');
        $(event.target).attr('aria-label', 'Remove applied onboard credit');
        $('.obc-summary-container').removeClass('d-none');
        $('.obc-summary-container .cost-value').html(`-$${res.orderSummary.obcAmount.toFixed(2)}`);
        if (Number(res.orderSummary.totalPriceWithTax) === 0) {
          $('.gift-card-body').addClass('disable-payment-div');
          $('.payment-card-body.card-div').addClass('disable-payment-div');
          $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').attr('tabindex', '-1').attr('aria-disabled', 'true');
          if (this.checkNameValidation()) {
            $('.btn.placeOrder').removeAttr('disabled');
          }
          $('.order-summary-total').attr('data-obc', 'OBC');
        }
        // Remove GIFT CARD on obc applied
        this.removeAllGC();
      } else {
        $('.js-obc-message').html(res.orderSummary.applicableOBCAmountDescription);
        $(event.target).removeClass('remove');
        $(event.target).html('Apply');
        $(event.target).attr('aria-label', 'Apply onboard credit');
        $('.obc-summary-container').addClass('d-none');
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.payment-card-body.card-div').removeClass('disable-payment-div');
        $('.btn.placeOrder').attr('disabled', 'disabled');
        $('.order-summary-total').data('obc', '');
        $('.order-summary-total')[0].dataset.obc = '';
        $('body').find('#order-bal').hide();
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').removeAttr('tabindex').removeAttr('aria-disabled');
        $('body').find('.gift-card-body').removeClass('gift-card-disabled');
      }
      gfunctions.updateCartSummary(res.orderSummary);
      $(event.target).toggleClass('btn-outline-black');
      $(event.target).toggleClass('btn-link');
      CCL.checkoutPaymentCard.disablingPlaceOrder();
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error occured on OBC flow');
    });
  },

  removeAllGC() {
    // Remove GIFT CARD on obc applied
    $('body').find('.add-gift-card').remove();
    $('body').find('.gift-card-body').removeClass('gift-card-disabled');
    $('body').find('#order-bal').hide();
    $('body').find('.gift-card-address').addClass('d-none');
    $('.gc-summary-container').addClass('d-none');
    $('.gc-summary-container .cost-value').html('');

    const $toggleButton = $('.toggle-btn');
    $toggleButton.removeClass('open');
    $toggleButton.addClass('collapsed');
    $toggleButton.removeAttr('aria-hidden');
    $toggleButton.attr('aria-expanded', 'false');
    $('body').find('.gift-card-body .collapse').removeClass('show');
  },

  addGiftCard() {
    $('body').on('click', '.apply-total', (event) => {
      event.preventDefault();
      this.targetElement = $(event.target).parents('.gift-card').find('.gift-card-title');
      this.submitGiftCard();
    });
  },

  removeGiftCard() {
    $('body').on('click', '.remove-gift-card', (e) => {
      const currentGiftCardNumber = $(e.currentTarget).parent().find('.giftCardNumber')[0].textContent;
      this.removedCurrentGiftCard(currentGiftCardNumber);
      $(e.currentTarget).parent().remove();
    });
  },

  async removedCurrentGiftCard(giftCardNumber) {
    const token = $('#csrfSessionToken').data('csrf');
    const endUrl = `/shop/checkout/multi/payment-method/remove/gift-card/${giftCardNumber}`;
    gfunctions.showLoader();
    try {
      const inputDataObj = {
        url: endUrl,
        type: 'GET',
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      };
      const responseData = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      gfunctions.updateCartSummary(responseData.orderSummary);
      const { orderSummary } = responseData;
      const { disableGiftCardApply, orderGCFulfilled, appliedGiftCards, orderBalance, totalPrice } = orderSummary;
      this.displayOrderBalance(totalPrice);
      const $toggleButton = $('.toggle-btn');
      if (!orderGCFulfilled) {
        $('.order-summary-total').text('');
        // $('.placeOrder').attr('disabled', 'disabled');
      }
      if (!disableGiftCardApply) {
        $('.gift-card').find('.gift-card-body').removeClass('gift-card-disabled');

        if (!appliedGiftCards.length) {
          $('#gift-card-bal').hide();
          $('#order-bal').hide();
          $('.gift-card-address').addClass('d-none');
          $toggleButton.removeClass('open');
          $toggleButton.addClass('collapsed');
          $toggleButton.removeAttr('aria-hidden');
          $toggleButton.attr('aria-expanded', 'false');
          setTimeout(() => {
            $toggleButton.addClass('ada-highlighted');
            $toggleButton.focus();
          }, 2000);
          $('#giftCardCollapse').removeClass('show');
          $('.gift-card-body .user-input-wrp').find('input').each((index, e) => {
            $(`#${e.id}`).val('');
            const $inputElement = $(`#${e.id}`).parent().find('.floating-label');
            $inputElement.removeClass('inputFocus');
            $inputElement.addClass('inputBlur');
          });
          $('#gc-state').prop('selectedIndex', 0);
          const $selectElement = $('#gc-state').parent().find('.floating-label');
          $selectElement.removeClass('inputFocus selectFocus');
          $selectElement.addClass('inputBlur selectBlur');
          // $selectElement.attr('style', 'top:31px !important');
        }
      }

      if (orderSummary.appliedGCAmount) {
        $('.gc-summary-container').removeClass('d-none');
        $('.gc-summary-container .cost-value').html(`-$${orderSummary.appliedGCAmount}`);
      } else {
        $('.gc-summary-container').addClass('d-none');
      }

      $('.payment-card-body.card-div').removeClass('disable-payment-div');
      $('.payment-card-body.card-div.disable-payment-div input, .payment-card-body.card-div.disable-payment-div a').removeAttr('tabindex');
      $('.btn.placeOrder').attr('disabled', 'disabled');


      CCL.checkoutPaymentCard.disablingPlaceOrder();
      $toggleButton.removeAttr('aria-hidden');
      $toggleButton.attr('aria-expanded', 'false');
      $toggleButton.removeAttr('tabindex');
      setTimeout(() => {
        $toggleButton.addClass('ada-highlighted');
        $toggleButton.focus();
      }, 2000);
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  displayOrderBalance(orderBalance) {
    console.log(orderBalance);
    if (orderBalance.trim() !== '') {
      const orderTotal = document.getElementById('order-bal');
      const orderTotalLabel = document.createTextNode(orderBalance);
      if (orderTotal.childNodes.length === 1) {
        orderTotal.appendChild(orderTotalLabel);
      } else if (orderTotal.childNodes.length > 1) {
        orderTotal.replaceChild(orderTotalLabel, orderTotal.childNodes[1]);
      }
      orderTotal.style.display = '';
    }

    /*
      We do not need to show order balance as per new req.
      so keeping all code as it is and just hiding it with js as of now
    */
    $('body').find('#order-bal').hide();
  },
  getGiftCardBalance() {
    $('body').on('click', '.gift-card-balance .btn-link', (e) => {
      this.giftCardBalance();
    });
  },

  async giftCardBalance() {
    const code = document.getElementById('cardNumber').value;
    const pin = document.getElementById('pinNumber').value;
    const ajaxUrl = `/shop/checkout/multi/payment-method/check/gift-card/${code}/${pin}`;
    const jsonData = {};
    jsonData.giftCardNumber = code;
    jsonData.giftCardPin = pin;
    gfunctions.showLoader();
    $('.gift-card-balance .error-msg').remove();
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: 'GET',
        contentType: 'application/json'
      };
      const responseData = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      if (responseData.gcBalance) {
        const giftCardBal = document.getElementById('gift-card-bal');
        const gcBalLabel = document.createTextNode(responseData.gcBalance);
        if (giftCardBal.childNodes.length === 1) {
          giftCardBal.appendChild(gcBalLabel);
        } else if (giftCardBal.childNodes.length > 1) {
          giftCardBal.replaceChild(gcBalLabel, giftCardBal.childNodes[1]);
        }
        giftCardBal.style.display = '';
      } else {
        /* eslint-disable */
        if (responseData.errors && responseData.errors.errors.length) {
          $.each(responseData.errors.errors, (index, value) => {
            $('.gift-card-balance').append(`<span class="error-msg">${value.message}</span>`);
          });
        }
        /* eslint-enable */
      }
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  async submitGiftCard() {
    gfunctions.showLoader();
    const code = document.getElementById('cardNumber').value;
    const pin = document.getElementById('pinNumber').value;
    const endUrl = '/shop/checkout/multi/payment-method/add/gift-card/';
    const token = $('#csrfSessionToken').data('csrf');
    const jsonData = {
      cardNumber: code,
      pinNumber: pin
    };

    try {
      const inputDataObj = {
        url: endUrl,
        type: 'POST',
        data: JSON.stringify(jsonData),
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      };
      const responseData = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      $('#giftCardCollapse .user-input-wrp').find('input').each((index, e) => {
        $(`#${e.id}`).val('');
        const $inputElement = $(`#${e.id}`).parent().find('.floating-label');
        $inputElement.removeClass('inputFocus');
        $inputElement.addClass('inputBlur');
      });
      const { orderSummary, errorMsg } = responseData;
      gfunctions.updateCartSummary(orderSummary);
      const { appliedGiftCards, disableGiftCardApply, orderBalance, appliedGCAmount, totalPrice } = orderSummary;
      this.displayOrderBalance(totalPrice);
      $('span.gift-card-error-message').remove();

      if (!errorMsg) {
        $('.gc-summary-container').removeClass('d-none');
        $('.gc-summary-container .cost-value').html(`-$${appliedGCAmount}`);
      }
      if (errorMsg) {
        $('.gift-card .gift-card-title').attr('role', 'alert');
        $('.gift-card .gift-card-title').attr('aria-live', 'assertive');
        $('.gift-card .gift-card-title').append($(`<span class="gift-card-error-message error-message pl-4 ml-4" role="alert">${errorMsg}</span>`));
        $('#cardNumber').addClass('ada-element-focus');
        setTimeout(() => {
          $('#cardNumber').focus();
        }, 3000);
      }
      $('div.add-gift-card').remove();
      $('#gift-card-bal').hide();
      for (let i = 0; i < appliedGiftCards.length; i++) {
        const currentGiftCard = appliedGiftCards[i];
        const { giftCardNumber, formattedDeductedGiftCardAmount, formattedRemainingGiftCardAmount } = currentGiftCard;
        if (formattedRemainingGiftCardAmount.toString() === ('0' || '0.0')) {
          $(this.targetElement).after(`<div class="add-gift-card"><div><span class="name">Gift Card</span><span class="giftCardNumber">${giftCardNumber}</span></div><div><span class="name">Applied</span><span>$ ${formattedDeductedGiftCardAmount}</span><br><span class="remaining">Remaining on gift card:</span><span> $ 0.00</span></div><a href="javascript:;" aria-label="Remove applied gift card" class="remove-gift-card" style="color: #0056b3;">Remove</a></div>`);
        } else {
          $(this.targetElement).after(`<div class="add-gift-card"><div><span class="name">Gift Card</span><span class="giftCardNumber">${giftCardNumber}</span></div><div><span class="name">Applied</span><span>$ ${formattedDeductedGiftCardAmount}</span><br><span class="remaining">Remaining on gift card:</span><span> $ ${formattedRemainingGiftCardAmount}</span></div><a href="javascript:;" aria-label="Remove applied gift card" class="remove-gift-card" style="color: #0056b3;">Remove</a></div>`);
        }
      }
      $('.remove-gift-card').addClass('ada-highlighted');
      $('.remove-gift-card').focus();
      if (disableGiftCardApply || Number(orderSummary.totalPriceWithTax) === 0) {
        $('.gift-card').find('.gift-card-body').addClass('gift-card-disabled');
        const $toggleButton = $('.toggle-btn');
        $toggleButton.removeClass('open');
        $toggleButton.addClass('collapsed');
        $toggleButton.attr('aria-hidden', 'true');
        $toggleButton.attr('tabindex', '-1');
        $toggleButton.attr('aria-expanded', 'false');
        $('#giftCardCollapse').removeClass('show');
      }
      if (orderSummary.orderGCFulfilled || Number(orderSummary.totalPriceWithTax) === 0) {
        $('.payment-card-body.card-div').addClass('disable-payment-div');
        $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').attr('tabindex', '-1').attr('aria-disabled', 'true');
        $('.order-summary-total').text('orderGCFulfilled');
        const $toggleButton = $('.toggle-btn');
        $toggleButton.removeClass('open');
        $toggleButton.addClass('collapsed');
        // $toggleButton.addClass('ada-highlighted');
        // $toggleButton.focus();
        $toggleButton.attr('aria-expanded', 'false');
        $('#giftCardCollapse').removeClass('show');
        setTimeout(() => {
          $('.remove-gift-card').addClass('ada-highlighted');
          $('.remove-gift-card').focus();
        }, 1000);
        const streetAddress = document.getElementById('gc-address').value;
        const city = document.getElementById('gc-city').value;
        const country = document.getElementById('gc-country').value;
        const state = document.getElementById('gc-state').value;
        const zip = document.getElementById('gc-zip').value;
        if (country.length && streetAddress.length && city.length && state.length && zip.length && this.checkNameValidation()) {
          $('.placeOrder').removeAttr('disabled');
        } else {
          setTimeout(() => {
            $('.gift-card-address .gift-card-title .error-message').remove();
            $('.gift-card-address .gift-card-title').append($('<span class="error-message pl-4 ml-4" role="alert">Please enter address details</span>'));
          }, 2000);
          $('.placeOrder').attr('disabled', 'disabled');
        }
      } else {
        $('.placeOrder').attr('disabled', 'disabled');
      }
      // $('.placeOrder').attr('disabled', 'disabled');
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },


  sendGiftCardAddress() {
    gfunctions.showLoader();
    const country = document.getElementById('gc-country').value;
    const streetAddress = document.getElementById('gc-address').value;
    const city = document.getElementById('gc-city').value;
    const state = document.getElementById('gc-state').value;
    const zip = document.getElementById('gc-zip').value;
    const token = $('#csrfSessionToken').data('csrf');
    const jsonData = { country, streetAddress, city, state, zipCode: zip };
    $.ajax({
      type: 'POST',
      url: '/checkout/multi/payment-method/send/gc-address/',
      data: JSON.stringify(jsonData),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      success: (data) => {
        gfunctions.hideLoader();
        console.log(data);
      },
      error: (error) => {
        gfunctions.hideLoader();
        console.log('inside error: ', error);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-gift-card/gift-card.js